import { GridRowId, GridValidRowModel } from "@mui/x-data-grid";
import { Dispatch, SetStateAction, createContext } from "react";
import { FieldValues } from "react-hook-form";
import { Form } from "../components/model/form-submit";

export type SectionErrorContextType = { [sectionId: string]: boolean };
export type SectionHideContextType = { [sectionId: string]: boolean };
export type SectionCompleteContextType = { [sectionId: string]: boolean };
export type StepToSectionContextType = { [stepId: number]: string };
export type FieldContextType = { [fieldId: string]: boolean };
export type FieldHideContextType = { [fieldId: string]: boolean };
export type FieldDisableContextType = { [fieldId: string]: boolean };

// Type for AutoComplete options
export type OptionType = { id: string; value: string };
export type AutoCompleteOptions = {
  [fieldId: string]: {
    originalOptions: OptionType[];
    currentOptions: OptionType[];
  };
};

export type SectionStateContextType = {
  errorState: SectionErrorContextType;
  hideState: SectionHideContextType;
  stepToSection: StepToSectionContextType;
  completeState: SectionCompleteContextType;
};
export type CheckBoxContextType = {
  checked: CheckBoxCheckedContextType;
};
export type CheckBoxCheckedContextType = { [fieldId: string]: boolean };
export type AppContextType = {
  sectionState: SectionStateContextType;
  fieldState: FieldContextType;
  fieldHide: FieldHideContextType;
  fieldDisable: FieldDisableContextType;
  checkboxChecked: CheckBoxContextType;
  autoCompleteOptions: AutoCompleteOptions; // Added for dynamic options
  fieldOptions?: { [fieldId: string]: OptionType[] }; // Added for field options
  initializationFlags?: { [key: string]: boolean }; // Added for initialization flags
};

export type StateContextType = {
  applicationContext: AppContextType;
  setApplicationContext: Dispatch<SetStateAction<AppContextType>>;
};

export const StateContext = createContext<StateContextType>({
  applicationContext: {
    sectionState: {
      errorState: {},
      hideState: {},
      completeState: {},
      stepToSection: {},
    },
    fieldState: {},
    fieldHide: {},
    fieldDisable: {},
    checkboxChecked: {
      checked: {},
    },
    autoCompleteOptions: {}, // Initialize autoCompleteOptions
    fieldOptions: {}, // Initialize fieldOptions
    initializationFlags: {}, // Initialize initializationFlags
  },
  setApplicationContext: (value: SetStateAction<AppContextType>): void => {
    throw new Error("Function not implemented.");
  },
});

export type GridRowEditContextType = {
  [sectionId: string]: GridRowId | undefined;
};
export type ListViewErrorState = {
  state: boolean;
  message: string | undefined;
};

export type ListViewRowModel = {
  guid: string;
  dataModel: FieldValues;
  rowModel: GridValidRowModel;
};

export type ListViewSubmitDataModel = {
  guid: string;
  listItem: Form;
};

export type ListViewDataModel = {
  uiModel: Array<ListViewRowModel>;
  submitRecordModel: Array<ListViewSubmitDataModel>;
};

export type GridToModel = { [rowId: number]: FieldValues };
export type ListViewsContextType = { [sectionId: string]: ListViewContextType };
export type ListViewContextType = {
  dataModel: ListViewDataModel;
  errorState: ListViewErrorState;
  editRow: string | undefined;
  expanded: boolean;
  minimumNumberOfRows: number;
};

export type ListViewStateContextType = {
  listViewsState: ListViewsContextType;
  setListViewsState: React.Dispatch<React.SetStateAction<ListViewsContextType>>;
};

export const ListViewContext = createContext<ListViewStateContextType>({
  listViewsState: {},
  setListViewsState: function (
    value: SetStateAction<ListViewsContextType>
  ): void {
    throw new Error("Function not implemented.");
  },
});
